import React from 'react';
import classNames from 'classnames';
import { IconButton } from '@mui/material';
import Header from '../../../../components/shared/header';
import { NavigationSelector, NavigationOption } from '../../../../components/shared/navigation-selector';
import CreateNewButtonV2 from '../../../../components/shared/create-new-button-v2';
import { SVGS } from '../../../../assets/images';
import { Lx } from '../../../../i18n/consts';
import styles from '../../projects.module.scss';

interface ProjectHeaderProps {
    isMobile: boolean;
    showMobileFilterToggle: boolean;
    isFilterOpen: boolean;
    onMobileFilterClick: () => void;
    canCreate: boolean;
    onCreateClick: () => void;
    typeOptions: NavigationOption[];
    selectedTypeValue: string;
    onTypeSelect: (value: string) => void;
    onMobileFilterClose?: () => void;
    loading?: boolean;
}

const ProjectHeader: React.FC<ProjectHeaderProps> = ({
    isMobile,
    showMobileFilterToggle,
    isFilterOpen,
    onMobileFilterClick,
    canCreate,
    onCreateClick,
    typeOptions,
    selectedTypeValue,
    onTypeSelect,
    onMobileFilterClose,
    loading,
}) => {
    const isMobileFilterActive = isMobile && isFilterOpen;

    return (
        <div className={styles.header}>
            <div className={styles.topRow}>
                <div className={styles.title}>
                    <Header headerLocalizationId={Lx.General.PROJECTS} loading={loading}>
                        {typeOptions.length ? (
                            <NavigationSelector
                                options={typeOptions}
                                value={selectedTypeValue}
                                onSelect={option => onTypeSelect(option.value)}
                            />
                        ) : null}
                    </Header>
                </div>
                <div className={styles.actions}>
                    {isMobile ? (
                        showMobileFilterToggle ? (
                            <IconButton
                                aria-label='filterIconButton'
                                onClick={() => {
                                    if (isFilterOpen) {
                                        onMobileFilterClose?.();
                                    }
                                    onMobileFilterClick();
                                }}
                                className={styles.filterButton}>
                                <SVGS.FilterIcon className={classNames({[styles.active]: isMobileFilterActive})} />
                            </IconButton>
                        ) : null
                    ) : (
                        canCreate ? <CreateNewButtonV2 onClick={onCreateClick} /> : null
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProjectHeader;
